import styled from 'styled-components';

import { heading1, heading3, largeParagraph, smallCapsSubtext } from 'components/core/typography';

export const Paragraph = styled.p`
  ${largeParagraph}
  margin-top: 20px;
  max-width: 326px;
`;
export const Header = styled.h1`
  ${heading1}
  line-height: 48px;
  font-weight: bold;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    font-size: 34px;
    line-height: 37px;
  }
`;

export const H2 = styled.h2`
  line-height: 48px;
  font-weight: bold;
  font-size: 34px;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    ${heading1}
  }
`;

export const Label = styled.p`
  font-size: 17px;
  line-height: 30px;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    ${largeParagraph}
  }
`;

export const Title = styled.h3`
  ${heading3};
  font-weight: bold;
  line-height: 24px;
  padding-top: 15px;
`;

export const Meta = styled.p`
  ${smallCapsSubtext};
  color: ${({ theme }) => theme.colors.grey[60]};
  padding-top: 10px;
`;
